import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import ReactGA from "react-ga";

function App() {
  ReactGA.initialize("UA-216575676-1");
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
